
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Les meilleures agences SEO en France - Top 2026",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez le classement 2026 des 15 meilleures agences SEO en France. Comparez leurs points forts et choisissez le partenaire idéal pour optimiser votre visibilité.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Les meilleures agences SEO en France - Top 2026",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez le classement 2026 des 15 meilleures agences SEO en France. Comparez leurs points forts et choisissez le partenaire idéal pour optimiser votre visibilité.",
        },
      ],
    };
  },
};
